import { motion } from "framer-motion";

export default function MetricCard({
  label,
  value,
  unit,
  icon: Icon,
  hint,
  accent = "#0EA5E9",
  testId,
  delay = 0,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className="metric-card p-6 md:p-7 relative overflow-hidden"
      data-testid={testId}
    >
      <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full opacity-[0.06]" style={{ background: accent }} />
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-slate-500">{label}</p>
        {Icon && (
          <span className="h-9 w-9 rounded-full flex items-center justify-center" style={{ background: `${accent}14`, color: accent }}>
            <Icon className="h-4 w-4" />
          </span>
        )}
      </div>
      <div className="mt-5 flex items-baseline gap-1.5">
        <span className="font-display text-4xl md:text-5xl font-light text-[#0B132B] leading-none" data-testid={`${testId}-value`}>
          {value}
        </span>
        {unit && <span className="text-sm text-slate-500 font-medium">{unit}</span>}
      </div>
      {hint && <p className="mt-3 text-xs text-slate-500">{hint}</p>}
    </motion.div>
  );
}
